<template>
    <design-2021-apprentice-display-html-component :html-content="slideIn.value"></design-2021-apprentice-display-html-component>
</template>

<script>
    export default {
        name: "design-2021-lesson-show-slide-text-component",
        props: ['slideIn'],
    }
</script>

<style>
	
	.lesson-slide-content {
		line-height: normal !important;
	}

	.lesson-slide-content p {
		line-height: normal !important;
		font-size: 1.5em;
	}

	.lesson-slide-content ul li, .lesson-slide-content ol li {
		font-size: 1.5em;
	}

	.lesson-slide-content h1, .lesson-slide-content h2, .lesson-slide-content h3, .lesson-slide-content h4, .lesson-slide-content h5, .lesson-slide-content h6  {
	    margin-block-end: 0em;
	    margin-block-end: 0.67em;
	    margin-inline-start: 0px;
	    margin-inline-end: 0px;
	}

</style>